import React from 'react';

export const UserCard = ({ user, displayType, onClick }) => {
    return (
        <div className={`user-card ${displayType}`} onClick={onClick}>
            {displayType === 'list' ? (
                <>
                    <div className="content">
                        <h3>{user.name}</h3>
                        <p>{user.email}</p>
                    </div>
                </>
            ) : (
                <>
                    <h3>{user.name}</h3>
                    <p>{user.email}</p>
                </>
            )}
        </div>
    );
};

export default UserCard;
